<template>
<!--         :activePanels="[0]" -->
    <BaseEditPage
        :context="context+'s'"
        :alvqa="alvqa"
        cancelIconRoute="/publishing/sheets"
    >
<!-- HEADLINE  -->    
        <template v-slot:headline="{ data }">
            <div class="d-flex align-center">
                <div :alvqa="alvqa + '-title'">
                    {{ data.title ? data.title : $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') }}
                </div>
                <div class="ml-2" style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
                    <ContextHelpIcon
                        v-if="hasContextHelp && helpContext"
                        :context="helpContext"
                        :alvqa="alvqa + '-context-help-icon'"
                    />
                </div>
            </div>
        </template>
<!-- EDIT FORM  -->
        <template v-slot:editForm>
            <PdfUploadDialog />

            <!-- 1st column -->
            <v-col cols="2">
                <v-row>
                    <v-col>
                        <!-- FILM/TV -->
                        <v-img v-if='getSheetsType == "film/tv"'
                            aspect-ratio="1"
                            class="avatar-300"
                            :alvqa="alvqa + '-image'"
                            :src="require('@/assets/default_picture/avatar/avatar-300-cameraman-kneeling.png')"
                        ></v-img>
                        <!-- MUSIKFOLGE -->
                        <v-img v-else
                            aspect-ratio="1"
                            class="avatar-300"
                            :alvqa="alvqa + '-image'"
                            :src="require('@/assets/default_picture/avatar/avatar-300-musician-with-guitar.png')"
                        ></v-img>                        
                    </v-col>
                </v-row>
            </v-col>

            <!-- 2nd column -->
            <v-col cols="2">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Title"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_TITLE')"
                        :alvqa="alvqa + '-textfield-title'"
                        rules="required"
                    />
                </v-row> 
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Tag"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_TAGS')"
                        :alvqa="alvqa + '-textfield-tag'"
                    />
                </v-row> 
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context"
                        field="Note"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_NOTE')"
                        :alvqa="alvqa + '-textarea-note'"
                    />
                </v-row>
            </v-col>  

            <!-- 3rd column -->
            <v-col cols="2"> 
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_CAPTION_ALVID')"
                        :clearable="false"
                        :readonly="true"
                        :alvqa="alvqa + '-textfield-alvid'"
                    />
                </v-row>

                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Type"
                        :items="sheetsTypeOptions"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_TYPE')"
                        :clearable="false"
                        :selection="true"
                        rules="required"
                        :disabled="!($route.params.alvId === 'new')"
                        :alvqa="alvqa + '-dropdown-type'"
                    />
                </v-row>

                <v-row v-if='getSheetsType == "film/tv"'>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="CompletenessCuesheetYesNo"
                        :items="completenessCuesheetYesNo"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_COMPLETENESS_CUESHEET_YESNO')"
                        :clearable="false"
                        :selection="true"
                        rules="required"
                        :alvqa="alvqa + '-dropdown-type-completeness-cuesheet-yesno'"
                    />
                </v-row>

                <v-row v-if='getSheetsType == "film/tv"'>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="CommissionedWorkYesNo"
                        :items="commissionedWorkYesNo"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_COMMISSIONED_WORK_YESNO')"
                        :clearable="true"
                        :selection="true"
                        :rules="isCommissionedWorkRequired"
                        :alvqa="alvqa + '-dropdown-type-commissioned-work-yesno'"
                    />
                </v-row>

                <v-row v-if='getSheetsType == "film/tv"'>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="CommissioningChannel"
                        :items="commissioningChannels"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_COMMISSIONING_CHANNEL')"
                        :clearable="true"
                        :selection="true"
                        :rules="isCommissioningChannelRequired"
                        :alvqa="alvqa + '-dropdown-type-commissioning-channel'"
                    />
                </v-row>

                <v-row v-if='getSheetsType == "film/tv"'>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="SynchronizationRights"
                        :items="synchronizationRights"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SYNCHRONIZATION_RIGHTS')"
                        :clearable="true"
                        :selection="true"
                        :rules="isSyncRightsRequired"
                        :disabled="isSyncRightsDisabled"
                        :alvqa="alvqa + '-dropdown-type-synchronization-rights'"
                    />
                </v-row>
            </v-col>  

            <!-- the following columns are TYPE-dependent -->
            
            <!-- FILM/TV: 4th column -->  
            <v-col v-if='getSheetsType == "film/tv"' cols="2">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="ProductionYear"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_PRODUCTION_YEAR')"
                        rules="sheetProductionYearBetween|sheetValidProductionYear"
                        :rules="isProductionYearRequired"
                        :alvqa="alvqa + '-textfield-production-year'"                        
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown
                        :context="context"
                        field="ProductionCountry"
                        :items="countries"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_PRODUCTION_COUNTRY')"
                        :selection="true"
                        :clearable="false"
                        rules="required"
                        :alvqa="alvqa + '-dropdown-production-country'"
                        v-model="productionCountry"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="FirstBroadcastDate"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_FIRST_BROADCAST_DATE')"
                        :alvqa="alvqa + '-datepicker-first-broadcast-date'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="AvType"
                        :items="sheetsAvTypeOptions"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_AV_TYPE')" 
                        :clearable="false"
                        :selection="true"
                        rules="required"
                        :alvqa="alvqa + '-dropdown-av-type'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="AvFirstExploitation"
                        :items="sheetsAvFirstExploitationOptions"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_AV_FIRST_EXPLOITATION')" 
                        :clearable="false"
                        :selection="true"
                        rules="required"
                        :alvqa="alvqa + '-dropdown-av-first-exploitation'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="AvMessageType"
                        :items="sheetsAvMessageTypeOptions"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_AV_MESSAGE_TYPE')" 
                        :clearable="false"
                        :selection="true"
                        rules="required"
                        :alvqa="alvqa + '-dropdown-av-message-type'"
                    />
                </v-row>
            </v-col>   

            <!-- SETLIST: 4th column -->
            <v-col v-else-if='getSheetsType == "setlist"' cols="2">
                <v-row> 
                    <!-- setSheetDetailsSetDate -->
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="SetDate" 
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_SET_DATE')"
                        :alvqa="alvqa + '-datepicker-setlist-set-date'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="SetStartTime"
                        :label="getSetTimeCaption('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_SET_START_TIME')"
                        :alvqa="alvqa + '-textfield-setlist-set-start-time'"
                        rules="timeHoursMinutes|required"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageTextField 
                        :context="context"
                        field="SetEndTime"
                        :label="getSetTimeCaption('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_SET_END_TIME')"
                        :alvqa="alvqa + '-textfield-setlist-set-end-time'"
                        rules="timeHoursMinutes|required"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageDropdown 
                        :context="context"
                        field="SetType"
                        :items="sheetsSetTypeOptions"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_SET_TYPE')"
                        :selection="true"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-setlist-set-type'"
                    />
                </v-row>
            </v-col>   

            <!-- FILM/TV: 5th column --> 
            <v-col v-if='getSheetsType == "film/tv"' cols="2">

                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="SheetNumber"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SHEET_NUMBER')"
                        rules="notZero"
                        :alvqa="alvqa + '-textfield-sheet-number'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageCombobox 
                        :context="context"
                        field="VersionType"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_VERSION_TYPE')"
                        :multiple="true"
                        :alvqa="alvqa + '-autocomplete-version-type'"
                    />
                </v-row> 
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Regions"
                        :items="sheetsRegionsOptions"
                        :clearable="false"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_REGIONS')"
                        :alvqa="alvqa + '-dropdown-regions'"
                    />
                </v-row>

                <v-row>
                    <BaseEditPageCombobox 
                        :context="context"
                        field="CarrierType"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_RELEASES_TYPE')"
                        :alvqa="alvqa + '-autocomplete-carrier-type'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Producer"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_PRODUCER')"
                        :rules="isProducerRequired"
                        :alvqa="alvqa + '-textfield-film-tv-producer'"
                    />
                </v-row>
            </v-col>

            <!-- SETLIST: 5th column --> 
            <v-col v-else-if='getSheetsType == "setlist"' cols="2">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="EventName"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_NAME')"
                        :alvqa="alvqa + '-textfield-setlist-event-name'"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageDropdown 
                        :context="context"
                        field="EventType"
                        :items="sheetsEventTypeOptions"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_TYPE')"
                        :selection="true"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-setlist-event-type'"
                    />
                </v-row>
                <v-row>
                    <v-col class="pa-0 ma-0" cols="10">
                        <BaseReadOnlyTextField
                            :innerValue="getVenue"
                            :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_VENUE')"
                            :alvqa="alvqa + '-textfield-venue-name'"
                        />
                    </v-col>
                    <v-col class="justify-end d-flex ml-0 pl-0" cols="2">
                        <BaseIcon   
                            :alvqa="alvqa + '-icon-edit-venue-name'"
                            :icon="isVenueConnected ? 'delete' : 'edit'" 
                            :tooltipText="isVenueConnected ? 'lang_GENERIC_CAPTION_DELETE' : 'lang_PUBLISHING_SHEETS_CAPTION_CONNECT_VENUE'"   
                            @click="editConnectedVenue()"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="EventVenueSpace"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_VENUE_SPACE')"
                        :alvqa="alvqa + '-textfield-setlist-event-venue-space'"
                        rules="required"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="EventVenueType"
                        :items="sheetsVenueTypeOptions" 
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_VENUE_TYPE')"
                        :alvqa="alvqa + '-dropdown-setlist-event-venue-type'"
                        :clearable="false"
                    />
                </v-row>  
                <v-row>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="EventOrganizer"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_ORGANIZER')"
                        :withFreeText="false"
                        rules="required"
                        :alvqa="alvqa + '-autocomplete-setlist-event-organizer'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-setlist-event-organizer-selection'">
                                {{ item.name }}
                            </div>
                        </template>

                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-setlist-event-organizer-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-setlist-event-organizer-dropdown-' + items.alvId + '-title'">
                                    {{ items.name }}
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-setlist-event-organizer-dropdown-' + items.alvId + '-subtitle'">
                                    {{ items.alvId }}                                      
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="EventOrganizerYesNo"
                        :items="eventOrganizerYesNoItems" 
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_ORGANIZER_YESNO')"
                        :alvqa="alvqa + '-dropdown-setlist-event-organizer-yesno'"
                        :clearable="false"
                        rules="required"
                    />
                </v-row> 
            </v-col>

            <!-- FILM/TV: 6th column --> 
            <v-col v-if='getSheetsType == "film/tv"' cols="2">
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Internet"
                        :items="internetOptions"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_INTERNET')"
                        :selection="true"
                        :alvqa="alvqa + '-dropdown-internet'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Platform"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_PLATFORM')"
                        :alvqa="alvqa + '-textfield-platform'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Provider"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_PROVIDER')"
                        :alvqa="alvqa + '-textfield-provider'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Url"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_URL')"
                        :alvqa="alvqa + '-textfield-url'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="ProducerEmail"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_PRODUCER_EMAIL')"
                        :rules="isProducerRequired"
                        :alvqa="alvqa + '-textfield-film-tv-producer-email'"
                    />
                </v-row>
            </v-col>

            <!-- SETLIST: 6th column --> 
            <v-col v-else-if='getSheetsType == "setlist"' cols="2">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Status"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_STATUS')"
                        :alvqa="alvqa + '-textfield-setlist-status'"
                    />
                </v-row> 
                <v-row>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="EventBandleader"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_BANDLEADER')"
                        :withFreeText="false"
                        rules="required"
                        :alvqa="alvqa + '-autocomplete-setlist-event-bandleader'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-setlist-event-bandleader-selection'">
                                {{ item.name }}
                            </div>
                        </template>

                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-setlist-event-bandleader-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-setlist-event-bandleader-dropdown-' + items.alvId + '-title'">
                                    {{ items.name }}
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-setlist-event-bandleader-dropdown-' + items.alvId + '-subtitle'">
                                    {{ items.alvId }}                                      
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-row> 
                <v-row>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="EventPerformer"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_PERFORMER')"
                        :withFreeText="false"
                        rules="required"
                        :alvqa="alvqa + '-autocomplete-setlist-event-performer'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-setlist-event-performer-selection'">
                                {{ $alvPlugin.showNameOfAzEntry(item, true) }}
                            </div>
                        </template>

                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-setlist-event-performer-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-setlist-event-performer-dropdown-' + items.alvId + '-title'">
                                    {{ $alvPlugin.showNameOfAzEntry(items, false) }}
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-setlist-event-performer-dropdown-' + items.alvId + '-subtitle'">
                                    {{ items.alvId }}                                      
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-row> 
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="EventHighestTicketPrice"
                        rules="integer|rangeinteger_1-9999"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_HIGHEST_TICKET_PRICE')"
                        :alvqa="alvqa + '-textfield-setlist-event-highest-ticket-price'"
                    />
                </v-row> 
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="EventNumberOfConcertgoers"
                        rules="integer"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_NUMBER_OF_CONCERTGOERS')"
                        :alvqa="alvqa + '-textfield-setlist-event-number-of-concertgoers'"
                    />
                </v-row> 
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="EventNumberOfMusicians"
                        rules="integer"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_NUMBER_OF_MUSICIANS')"
                        :alvqa="alvqa + '-textfield-setlist-event-number-of-musicians'"
                    />
                </v-row> 
            </v-col>

        </template>  
        
<!-- PANELS -->
        <template v-slot:panels>
            <ContextHelpDialog />
            <ConnectVenueToSheetDialog />
            <DeletionDialog :useContextSetinVuex="true" />
            <!-- WORKS -->
            <WorksPanel />
            <WorksEditPanelDialog />
            <SheetsWorksPanelAddWorksDialog />            
            <!-- PDF -->
            <PdfSheetPanel />
        </template>     
    </BaseEditPage>
</template>

<script>
import 
    { 
        DropdownPublishingSheetsInternetOptions,
        DropdownPublishingSheetsTypeOptions,
        DropdownPublishingSheetsSetTypeOptions,
        DropdownPublishingSheetsEventTypeOptions,
        DropdownPublishingSheetsVenueTypeOptions,
        DropdownGenericYesNo,
        DropdownPublishingSheetsAvTypeOptions,
        DropdownPublishingSheetsAvFirstExploitationOptions,
        DropdownPublishingSheetsAvMessageTypeOptions,
        DropdownPublishingSheetsCommissioningChannelOptions,
        DropdownPublishingSheetsSynchronizationRightsOptions
    } 
from '@/assets/dropdowns/alvDropdowns.js'

import BaseEditPage             from '@/components/_base/BaseEditPage'
import BaseIcon                 from '@/components/_buttons/BaseIcon'
import BaseEditPageTextField    from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageTextarea     from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDatePicker   from '@/components/_editForm/BaseEditPageDatePicker'
import BaseEditPageCombobox     from '@/components/_editForm/BaseEditPageCombobox'
import BaseEditPageDropdown     from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BaseReadOnlyTextField    from '@/components/_readonly/BaseReadOnlyTextField'

import WorksPanel               from './_panels/1_works/WorksPanel'
import PdfSheetPanel            from './_panels/2_pdf/PdfSheetPanel'

import ContextHelpIcon          from '@/components/_buttons/ContextHelpIcon'
import ContextHelpDialog        from '@/components/_dialogs/ContextHelpDialog'

import PdfUploadDialog          from '../_buttons/PdfUploadDialog'
import DeletionDialog           from '@/components/_dialogs/DeletionDialog'
import ConnectVenueToSheetDialog from './_dialogs/ConnectVenueToSheetDialog'
import WorksEditPanelDialog             from './_panels/1_works/WorksEditPanelDialog'
import SheetsWorksPanelAddWorksDialog   from './_panels/1_works/SheetsWorksPanelAddWorksDialog'

export default {
    name: "SheetsEdit",
    components: {
        BaseEditPage,
        BaseIcon,
        BaseEditPageTextField,
        BaseEditPageTextarea,
        BaseEditPageDatePicker,
        BaseEditPageCombobox,
        BaseEditPageDropdown,
        BaseEditPageAutocomplete,
        BaseReadOnlyTextField,

        ContextHelpIcon,
        ContextHelpDialog,

        WorksPanel,
        PdfSheetPanel,

        PdfUploadDialog,
        DeletionDialog,
        ConnectVenueToSheetDialog,
        WorksEditPanelDialog,
        SheetsWorksPanelAddWorksDialog
    },
    data() {
        return {
            context: "Sheet",
            alvqa: "publishing-sheets-edit-form",
            hasContextHelp: false
        }
    },
    watch: {
        helpContext: {
            immediate: true,
            async handler(ctx) {
                if (!ctx) {
                    this.hasContextHelp = false
                    return
                }
                this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability(ctx)
            }
        }
    },
    computed: {
        helpContext() {
            const type = this.getSheetsType
            if (type === 'film/tv') return 'PublishingSheetsEditFilmTv'
            if (type === 'setlist') return 'PublishingSheetsEditSetlist'
            return null
        },
        // Dropdown options
        internetOptions() {  return  DropdownPublishingSheetsInternetOptions },
        sheetsTypeOptions() { return DropdownPublishingSheetsTypeOptions },
        sheetsSetTypeOptions() { return DropdownPublishingSheetsSetTypeOptions },
        sheetsEventTypeOptions() { return DropdownPublishingSheetsEventTypeOptions },
        sheetsVenueTypeOptions() { return DropdownPublishingSheetsVenueTypeOptions },
        eventOrganizerYesNoItems() { return DropdownGenericYesNo },
        sheetsAvTypeOptions(){return DropdownPublishingSheetsAvTypeOptions},
        sheetsAvFirstExploitationOptions() { return DropdownPublishingSheetsAvFirstExploitationOptions },
        sheetsAvMessageTypeOptions() { return DropdownPublishingSheetsAvMessageTypeOptions },

        homeSocietyCode() { return this.$store.getters.getHomeSocietyCode },
        getSheetsType() { return this.$store.getters.getSheetDetailsType },
        getVenue() { 
            if(this.$store.getters.getSheetDetailsEventVenue !== null) return this.$store.getters.getSheetDetailsEventVenue.name
            else return this.$store.getters.getSheetDetailsEventVenue 
        },
        isVenueConnected() { return this.getVenue !== null },
        completenessCuesheetYesNo(){ return DropdownGenericYesNo },
        commissionedWorkYesNo(){ return DropdownGenericYesNo },
        isProductionYearRequired(){
            if(this.$store.getters.getSheetDetailsAvType == 'FILM' || this.$store.getters.getSheetDetailsAvType == 'EPISODE'){
                return 'required'
            }
            return ''
        },
        isRegionsRequired(){
            if(this.$store.getters.getSheetDetailsAvType == 'FILM'){
                return 'required'
            }
            return ''
        },
        commissioningChannels(){ return DropdownPublishingSheetsCommissioningChannelOptions },
        synchronizationRights(){ return DropdownPublishingSheetsSynchronizationRightsOptions },
        isSyncRightsRequired(){
            if(this.$store.getters.getSheetDetailsAvType == 'FILM'){
                return 'required'
            }
            return ''
        },
        isSyncRightsDisabled(){
            let firstExploitation = this.$store.getters.getSheetDetailsAvFirstExploitation
            let commissioned = this.$store.getters.getSheetDetailsCommissionedWorkYesNo
            let productionTerritories = this.$store.getters.getSheetDetailsRegions
            
            // Check if Germany (value === 1) is selected
            let hasGermany = false
            if (productionTerritories) {
                if (Array.isArray(productionTerritories)) {
                    hasGermany = productionTerritories.some(territory => territory.value === 1)
                } else if (productionTerritories.value) {
                    hasGermany = productionTerritories.value === 1
                }
            }
            
            // see validation rules in https://alvdigital.atlassian.net/browse/ALVCODE-1024
            if ((firstExploitation == 'TELEVISION' || firstExploitation == 'COMMERCIAL') && (commissioned == 'yes') && hasGermany){
                this.$store.commit('setSheetDetailsSynchronizationRights', null)
                return true
            }
        },
        isProducerRequired(){
            let producerEmail = this.$store.getters.getSheetDetailsProducerEmail
            let producer = this.$store.getters.getSheetDetailsProducer 
            if( producerEmail != null || producer != null){
                return 'required'
            }
            return ''
        },
        isCommissionedWorkRequired(){
            let avType = this.$store.getters.getSheetDetailsAvType
            let firstExploitation = this.$store.getters.getSheetDetailsAvFirstExploitation
            if(avType == 'EPISODE' && firstExploitation == 'TELEVISION'){
                return 'required'
            }
            return ''
        },
        isCommissioningChannelRequired(){
            let avType = this.$store.getters.getSheetDetailsAvType
            let firstExploitation = this.$store.getters.getSheetDetailsAvFirstExploitation
            if(avType == 'EPISODE' && firstExploitation == 'TELEVISION'){
                return 'required'
            }
            return ''
        },
        countries() {
            let countries = this.$alvPlugin.getListOfTranslatedCountries();
            
            // Get home country from user settings
            let homeCountry = this.$store.getters.getCompanyCountry;
            
            if (homeCountry && countries.length > 0) {
                // Find the home country in the list
                let homeCountryIndex = countries.findIndex(country => country.value === homeCountry);
                
                if (homeCountryIndex > -1) {
                    // Remove home country from current position
                    let homeCountryItem = countries.splice(homeCountryIndex, 1)[0];
                    // Add it to the beginning
                    countries.unshift(homeCountryItem);
                }
            }
            
            return countries;
        },

        productionCountry: {
            get() {
                return this.$store.getters.getSheetDetailsProductionCountry;
            },
            set(val) {
                this.$store.commit('setSheetDetailsProductionCountry', val);
            }
        },

        sheetsRegionsOptions() {
            // Fixed options for GEMA AV API: Germany and World
            // Using internal region IDs for database storage
            return [
                {
                    text: 'lang_PUBLISHING_SHEETS_CAPTION_GERMANY',
                    value: 1, // Internal region ID for Germany (maps to TIS 276 in API)
                    alvqa: 'dropdown-region-germany'
                },
                {
                    text: 'lang_GENERIC_REGIONS_WORLD',
                    value: 4, // Internal region ID for World (maps to TIS 2136 in API)
                    alvqa: 'dropdown-region-world'
                }
            ];
        }
    },
    methods: {
        openUploadialog() {
            let dialogText = this.$t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') + ' ' + this.$t('lang_PUBLISHING_SHEETS_DIALOG_SHEET_FILE') + '. <br />' + 
                             this.$t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE').replace("<join>", "PDF/ZIP")  

            this.$store.commit('setUploadPDFDialogText', dialogText)
            this.$store.commit('setShowUploadPDFDialog', true)
        },

        getSetTimeCaption(baseString) {
            let caption = this.$t(baseString)
            caption += " (HH:MM)" 
            return caption
        },

        copyVenueToOrganizer(venue) { // to avoid typing, copy selected venue to organizer field IF the latter is empty (no overwrite)
            let organizer = this.$store.getters.getSheetDetailsEventOrganizer
            if(venue !== null && venue !== undefined && organizer == null) {
                this.$store.commit('setSheetDetailsEventOrganizer', venue)
                this.$store.commit('setSheetEventOrganizerOptions', [venue])
            }  
        },

        editConnectedVenue() {
            if(this.isVenueConnected) {
                this.$store.commit('setSheetDetailsEventVenue', null)
                this.$store.commit('setSheetDetailsEventVenueId', null)
            } else this.$store.commit('setShowConnectVenueToSheetDialog', true)
        }
    }
}
</script>